import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';

export default memo(({ data }) => {
  const { targetClassColor } = data;
  return (
    <div>
      {/* Source handle for outgoing connections */}
      <Handle
        type='source'
        position={Position.Right}
        style={{ background: targetClassColor?.light }}
      />

      {/* Target handle for incoming connections */}
      <Handle
        type='target'
        position={Position.Left}
        style={{ background: targetClassColor?.dark }}
      />

      <div
        style={{
          textAlign: 'center',
          // color: targetClassColor?.contrastText || '#ffffff',
          fontSize: '10px',
          padding: '2px 4px',
        }}
      >
        {data.label}
      </div>
    </div>
  );
});
